
function scrollToListing(dataID) {

    var element;

    $(".installation-site__details").each( function () {

        if (dataID == $(this).attr('data-id')) {

            element = $(this);

        }

    });

    if (element.length > 0) {

        $("html, body").animate({
            scrollTop: ($(element).offset().top - 80)
        }, 600)

    }
}

function addEventToMarker(marker, givenString) {

    var infoWindow = new google.maps.InfoWindow({

        content: givenString,
        pixelOffset: new google.maps.Size(0, -6)

    });

    marker.addListener('click', function() {

        infoWindow.open(marker.get('siteLocationMap'), marker);

    });

}

function addChangeIcon( marker, onMouseover, onMouseout ) {

    google.maps.event.addListener(marker, 'mouseover', function() {
        marker.setIcon(onMouseover);
    });

    google.maps.event.addListener(marker, 'mouseout', function() {
        marker.setIcon(onMouseout);
    });

}

function returnMarkupString(name, postcode, type, distance, dataID) {

    return '<h4 class="hand" onClick="scrollToListing(' + dataID + ')" style="margin-top: 10px; color: #00AEC7;"> ' + name + '</h4><p style="font-size: 15px; margin-bottom: 5px; width: 100%; text-align: left;"><strong>Postcode:</strong> ' + postcode + '</p><p style="font-size: 15px;  margin-bottom: 5px; width: 100%; text-align: left;"><strong>Installation Type:</strong> ' + type + '</p><p style="font-size: 15px;  margin-bottom: 5px; width: 100%; text-align: left;"><strong>Distance:</strong> ' + distance + ' miles</p>';

}

function returnPlainMarkupString(name, postcode, type, distance) {

    return '<h4 style="margin-top: 10px; color: #00AEC7;"> ' + name + '</h4><p style="font-size: 15px; margin-bottom: 5px; width: 100%; text-align: left;"><strong>Postcode:</strong> ' + postcode + '</p><p style="font-size: 15px;  margin-bottom: 5px; width: 100%; text-align: left;"><strong>Installation Type:</strong> ' + type + '</p><p style="font-size: 15px;  margin-bottom: 5px; width: 100%; text-align: left;"><strong>Distance:</strong> ' + distance + ' miles</p>';

}